import React, { useEffect } from 'react';
import { getUserManager } from "../authentication-service.js";
export const SilentCallback = () => {
  useEffect(() => {
    getUserManager().signinSilentCallback();
  }, []);
  return /*#__PURE__*/React.createElement("div", null);
};
//# sourceMappingURL=silent-callback.js.map